import { Injectable, inject } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { map, delay } from 'rxjs/operators'
import { of } from 'rxjs'

import { CookieService } from 'ngx-cookie-service'
import type { User } from '@/app/store/authentication/auth.model'

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  user: User | null = null

  public readonly authSessionKey = '_REBACK_AUTH_SESSION_KEY_'
  private cookieService = inject(CookieService)

  constructor(private http: HttpClient) {}

  login(email: string, password: string) {
    // Mock authentication - accept any email/password
    // In production, replace this with actual backend call
    const mockUser: User = {
      id: 1,
      email: email,
      username: email.split('@')[0],
      firstName: 'Test',
      lastName: 'User',
      name: 'Test User',
      token: 'mock-jwt-token-' + Date.now(),
      avatar: 'assets/images/users/avatar-1.jpg',
      location: 'Mock Location',
      title: 'Developer'
    }

    // Simulate network delay
    return of(mockUser).pipe(
      delay(500),
      map((user) => {
        // login successful if there's a jwt token in the response
        if (user && user.token) {
          this.user = user
          // store user details and jwt in session
          this.saveSession(user.token)
        }
        return user
      })
    )
  }

  logout(): void {
    // remove user from cookie to log user out
    this.removeSession()
    this.user = null
  }



  get session(): string {
    return this.cookieService.get(this.authSessionKey)
  }
  
  saveSession(token: string): void {
    this.cookieService.set(this.authSessionKey, token)
  }

  removeSession(): void {
    this.cookieService.delete(this.authSessionKey)
  }
}
